<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :xl="16">
                    <el-form-item prop="avatar" label="群组图标:">
                        <image-upload :url.sync="formData.avatar" :urlFull.sync="formData.avatarFull" :min-width="200" :min-height="200"></image-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="群组名称:">
                        <el-input
                            placeholder="请输入群组名称"
                            v-model="formData.name"
                            maxlength="15"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="desc" label="描述:">
                        <el-input
                            placeholder="请输入群组描述"
                            v-model="formData.desc"
                            maxlength="100"
                            size="medium"
                            autosize
                            type="textarea"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="mainUserId" label="指定群主:">
                        <el-select
                            v-model="formData.mainUserId"
                            filterable
                            remote
                            placeholder="请选择指定群组"
                            :remote-method="searchMainUser"
                            :loading="userLoading"
                            size="medium">
                            <el-option
                                v-for="item in mainUserList"
                                :key="item.id"
                                :label="`${item.name}(${item.id})`"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="adminUserIdList" label="指定管理:">
                        <el-select
                            v-model="formData.adminUserIdList"
                            multiple
                            filterable
                            remote
                            placeholder="请输入群组管理"
                            :remote-method="searchAdminUser"
                            :loading="userLoading"
                            size="medium">
                            <el-option
                                v-for="item in adminUserList"
                                :key="item.id"
                                :label="`${item.name}(${item.id})`"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="size" :label="formData.joinCount ? '人数上限 (已加入'+formData.joinCount+'人):' : '人数上限:'">
                        <el-input
                            placeholder="请输入人数上限"
                            v-model="formData.size"
                            :min="formData.joinCount || 0"                           
                            :max="2000"
                            size="medium"
							type="number"							
							@blur="numberChange()"
                        ></el-input>
                        <small>
                            <span class="el-icon-warning"></span>  
                            每个群组最多<span class="color-danger">2000</span>人，请输入不大于2000的整数
                        </small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="invalidDate" label="失效时间:">
                        <el-date-picker
                            v-model="formData.invalidDate"
                            type="datetime"
                            placeholder="请选择失效时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            size="medium">
                        </el-date-picker>
						<small>
						    <span class="el-icon-warning"></span>  
						   失效后，群组将会在列表<span class="color-danger">隐藏，但不会解散</span>
						</small>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="joinBuy" label="购票入群规则:">
                        <el-radio-group v-model="formData.joinBuy" size="medium">
                            <el-radio :label="1">购票后自动入群</el-radio>
                            <el-radio :label="2">购票后手动入群</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="joinNotBuy" label="未购票入群规则:">
                        <el-radio-group v-model="formData.joinNotBuy" size="medium">
                            <el-radio :label="1">允许入群</el-radio>
                            <el-radio :label="2">禁止入群</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="isAudi" label="入群审核设置:">
                        <el-radio-group v-model="formData.isAudi" size="medium">
                            <el-radio :label="1">需要审批才能入群</el-radio>
                            <el-radio :label="2">不需要审批就可入群</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :xl="16">
                    <el-form-item prop="activityIdList" label="绑定演出:">
                        <el-input v-model="bindingId" class="input-with-select" placeholder="请输入演出或巡演ID" size="medium">
                            <el-select
                                v-model="bindingType"
                                slot="prepend"
                                placeholder="请选择"
                            >
                                <el-option label="演出ID" :value="1"></el-option>
                                <el-option label="巡演ID" :value="2"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                        </el-input>
                        <small class="from-tip"><span class="el-icon-warning"></span> 通过ID查询并绑定相关演出</small>
                        <el-table
                            v-if="activityList && activityList.length > 0"
                            :data="activityList"
                            border
                            style="width: 100%"
                            size="small"
                        >
                            <el-table-column prop="id" label="演出ID"></el-table-column>
                            <el-table-column prop="title" label="演出名称"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-delete"
                                        @click="del(scope.row.id)"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="weixinPath" label="官方微信群:">
                        <image-upload :url.sync="formData.weixinPath" :urlFull.sync="formData.weixinPathFull" :width="590" :height="786" crop :is-clear="true"></image-upload>
                        <small>
                            <span class="el-icon-warning"></span>  
                            受微信规则限制，配置时请注意人数达到一定量后用户将不能通过群二维码入群
                        </small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="官方QQ群:">
                        QQ群号码:
                        <el-input v-model="formData.qqNumber" placeholder="请输入QQ群号码" size="medium"></el-input>
                        IOS KEY:
                        <el-input v-model="formData.qqIosKey" placeholder="请输入QQ群IOS KEY" size="medium" maxlength="100"></el-input>
                        ANDROID KEY:
                        <el-input v-model="formData.qqAndroidKey" placeholder="请输入QQ群ANDROID KEY" size="medium" maxlength="100"></el-input>
                        <div>Key查询：<el-link href="https://qun.qq.com/join.html" target="_blank">https://qun.qq.com/join.html</el-link></div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import {fetchUser} from '@/assets/js/commonApi';
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components:{ImageUpload},
    data() {
        return {
            formData: {
                name:'',
                desc:'',
                mainUserId:'',
                adminUserIdList:[],
                size:'',
                joinBuy:1,
                joinNotBuy:1,
                isAudi:2,
                avatar:'',
                activityIdList:[],
                weixinPath:'',
                qqNumber:'',
                qqIosKey:'',
                qqAndroidKey:''
            },
            rules: {
                name: [{ required: true, message: "请输入群组名称" }],
                desc: [{ required: true, message: "请输入群组描述" }],
                mainUserId:[{ required: true, message: "请选择指定群主" }],
                size:[{ required: true, message: "请输入人数上限" }],
                activityIdList:[{ required: true, message: "请至少选择一场演出" }]
            },
            btnLoading: false,
            pageLoading: false,
            redirect: this.$route.query.redirect || "/operation/chatGroup/list",
            mainUserList:[],
            userLoading:false,
            adminUserList:[],
            bindingId:'',
            bindingType:1,
            activityList:[]
        };
    },
    created() {
        if (this.id) {
            this.getData();
        }
    },
    methods: {
        
        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/chatGroup/detail",
                method: "POST",
                data: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                        mainUserId: result.mainUser.id || '',
                        activityIdList:[],
                        adminUserIdList:[]
                    }
					console.log(this.formData)
                    this.mainUserList.push(result.mainUser);

                    this.adminUserList = result.adminUserList || [];
                    this.adminUserList.forEach( item => {
                        this.formData.adminUserIdList.push(item.id);
                    })

                    this.activityList = result.activityList || [];
                    this.activityList.forEach(item => {
                        this.formData.activityIdList.push(item.id);
                    })

                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
		numberChange () {
					
		    if( this.formData.size > 2000 ) {
				this.$message.error("已超过上限人数，重新输入");
				return false
			}
		},
        //表单提交
        onSubmit() {
					
			if( this.formData.size > 2000 ) {
				this.$message.error("已超过上限人数，重新输入");
				return;
			}else{
				this.$refs["formData"].validate((valid) => {
				    if (valid) {
				        this.btnLoading = true;
				        this.$request({
				            url: !this.id ? "/chatGroup/add" : "/chatGroup/edit",
				            method: "POST",
				            data: this.formData,
				        })
				            .then((res) => {
				                //处理成功回调
				                const { state, msg } = res.data;
				                if (state && state == 1) {
				                    this.goBack();
				                } else {
				                    return this.$message.error(msg || "操作失败");
				                }
				            })
				            .finally(() => {
				                this.btnLoading = false;
				            });
				    }
				});
			}
            
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
        async searchMainUser(query){
            this.searchUser(query,'mainUserList');
        },
        async searchAdminUser(query){
            this.searchUser(query,'adminUserList');
        },
        // 查找用户
        async searchUser(query,type){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType: 0
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    if( type == 'mainUserList' ){
                        this.mainUserList = result
                    }
                    if( type == 'adminUserList' ){
                        this.adminUserList = result
                    }
                }
            }
        },
         //搜索演出事件
        searchEvent() {
            if (this.bindingId !== "") {
                this.dataLoading = true;
                this.$request({
                    url: "/chatGroup/queryActivity",
                    data: { bindingId: this.bindingId,bindingType:this.bindingType,id: this.id || '' },
                    method: "post",
                })
                    .then((res) => {
                        const { state, result, msg } = res.data;
                        if (state == 1) {
                            if(result && result.length > 0){
                                result.map(item => {
                                    const _obj = this.activityList.find(v => v.id === item.id)
                                    if( !_obj ){
                                        this.activityList.push(item) ;
                                        this.formData.activityIdList = this.formData.activityIdList.concat(item.id);
                                        this.$refs["formData"].clearValidate('activityIdList');
                                        this.bindingId = ''
                                    }
                                })
                            }else{
                                this.$message.error(msg || '没有找到相关演出');
                            }
                        }else{
                            this.$message.error(msg || '没有找到相关演出');
                        }
                    }).catch(() => {
                        this.$message.error('系统错误');
                    }).finally(() => {
                        this.dataLoading = false;
                    });
            }
        },
        //删除演出
        del(id){
            const _msg = '确定要删除吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.activityList = this.activityList.filter( item => item.id !== id);
                this.formData.activityIdList = this.formData.activityIdList.filter( item => item !== id);
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.el-date-editor.el-input,.el-select{
    width: 100%;
}
.el-alert{
    line-height: normal;
}
</style>